import React from 'react';
import clsx from 'clsx';
import type { BoxContainerProps } from './types';
import styles from './styles/Container.module.scss';
import { useService } from '@wix/services-manager-react';
import { TranslationsDefinition } from '@wix/viewer-service-translations/definition';
import {
  ARIA_LABEL_DEFAULT,
  ARIA_LABEL_KEY,
  ARIA_LABEL_NAMESPACE,
} from './constants';

export default function BoxContainer({
  id,
  children,
  a11y,
  className,
  onClick,
  onDblClick,
  onMouseIn,
  onMouseOut,
  onFocus,
  onBlur,
}: BoxContainerProps) {
  const { translate } = useService(TranslationsDefinition);
  const t = translate(ARIA_LABEL_NAMESPACE);
  const ariaLabelInteractions = false; // TODO: once we have a service to replace hasChildrenWithHiddenAndHover (in carmi mapper) use it

  const ariaLabel = ariaLabelInteractions
    ? t(ARIA_LABEL_KEY) || ARIA_LABEL_DEFAULT
    : a11y?.['aria-label'];

  return (
    <div
      id={id}
      {...a11y}
      aria-label={ariaLabel}
      className={clsx(styles.root, 'container', className)}
      onClick={onClick}
      onDoubleClick={onDblClick}
      onMouseEnter={onMouseIn}
      onMouseLeave={onMouseOut}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {children}
    </div>
  );
}
